import styled from "styled-components/macro";

const TrendsPageIconStyles = styled.svg`
  width: 1em;
  padding: 4px;
  .cls-1 {
    fill: #fff;
  }
`;

const TrendsPageIcon = () => (
  <TrendsPageIconStyles
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14.95 18.8"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          className="cls-1"
          d="M10.09,0H0V18.8H15V4.86Zm2.36,4.43H10.52V2.5Zm-11,12.91V1.47H9.05V5.16a.74.74,0,0,0,.74.74h3.69V17.34Z"
        />
        <rect className="cls-1" x="3.27" y="14.57" width="8.41" height="0.98" />
        <rect className="cls-1" x="3.27" y="5.39" width="4.99" height="0.98" />
        <polygon
          className="cls-1"
          points="9.93 8.5 10.47 8.5 8.38 10.6 6.74 8.96 3.12 12.58 3.81 13.27 6.74 10.34 8.38 11.98 11.16 9.19 11.16 9.73 12.14 9.73 12.14 7.52 9.93 7.52 9.93 8.5"
        />
        <rect className="cls-1" x="3.27" y="3.25" width="4.99" height="0.98" />
      </g>
    </g>
  </TrendsPageIconStyles>
);

export default TrendsPageIcon;
